import { NodeIds } from '@breathelife/insurance-form-builder';
import { Answers, LocalizedInsuranceProduct, SelectedProductInformation } from '@breathelife/types';
import {
  deserializeNodeIdToAnswerPathMap,
  PivotAnswerResolver,
  SerializedNodeIdToAnswerPathMap,
  VersionedAnswers,
} from '@zinnia/form-engine-sdk';

import { ConsumerFlowStore } from '../Store';

export const getSelectedProductInformation = (
  state: ConsumerFlowStore,
  options?: { useApplicationMonthlyPremium?: boolean },
): SelectedProductInformation | null => {
  const { insuranceApplication, products = [] } = state.consumerFlow.insuranceApplication;

  if (options?.useApplicationMonthlyPremium) {
    // Not all carriers use the `products` array and/or the NodeIds.productId / NodeIds.coverageAmount nodeIds.
    return null;
  }

  const answersDataStructure = insuranceApplication?.answersDataStructure;
  const answersV1 = insuranceApplication?.answers ?? ({} as Answers);
  const answersV2 = insuranceApplication?.answersV2 ?? ({} as Answers);

  const blueprint = state.consumerFlow.step.blueprint;
  if (!blueprint) return null;

  const premium = insuranceApplication?.monthlyPremium;

  const nodeIdToAnswerPathMap = deserializeNodeIdToAnswerPathMap(
    answersDataStructure as SerializedNodeIdToAnswerPathMap,
  );

  const answersResolver = PivotAnswerResolver.from(
    new VersionedAnswers({ v1: answersV1, v2: answersV2 }),
    nodeIdToAnswerPathMap,
    blueprint,
    'v1',
  );

  const productId = nodeIdToAnswerPathMap.size && answersResolver.usingNodeId().getAnswer(NodeIds.productId, {});
  const coverageAmount =
    nodeIdToAnswerPathMap.size && answersResolver.usingNodeId().getAnswer(NodeIds.coverageAmount, {});

  const product = (products as Array<LocalizedInsuranceProduct>).find((product) => {
    return product.productId === productId && product.isEligible;
  });

  return premium && coverageAmount && product ? { ...product, premium, coverageAmount } : null;
};

export const getMonthlyPremiumFromApplication = (state: ConsumerFlowStore): number | undefined => {
  const { insuranceApplication } = state.consumerFlow.insuranceApplication;
  return insuranceApplication?.monthlyPremium;
};
